module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/add-customer/add-customer.component.css
// module id = ./src/app/add-customer/add-customer.component.css
// module chunks = main